module.exports = window["wc"]["components"];